module.exports = __webpack_public_path__ + "img/card-bg.a78f9c4e.svg";